import { Paper } from '@material-ui/core';
import asbvpercentile, { ASBVPercentile, ASBVPercentiles } from 'api/query/asbv';
import PercentileTag from 'components/percentile-tag';
import { ScrollShadow } from 'components/scroll-shadow/scroll-shadow';
import { usePrime } from 'pages/search/prime/use-prime';
import React, { useEffect, useState } from 'react';
import { getDisplayedPercentiles } from '../asbvs-utils';
import { ASBVPercentileTableProps } from './asbv-percentile-table-props';
import './asbv-percentile-table.scss';

export const ASBVPercentileTable: React.FC<ASBVPercentileTableProps> = ({ asbv, filterPercentiles }) => {
  const { primeFilters: { db } } = usePrime();
  const [loading, setLoading] = useState(true);
  const [asbvPercentiles, setASBVPercentiles] = useState<ASBVPercentiles>({} as ASBVPercentiles);
  const [percentiles, setPercentiles] = useState<ASBVPercentile[]>([]);

  const displayedPercentiles = filterPercentiles
    ? percentiles.filter(
      (a) => (a.percentileType === 1)
        || (a.percentileType === 5)
        || (a.percentileType === 10)
        || (a.percentileType === 20)
        || (a.percentileType === 50)
        || (a.percentileType === 90),
    )
    : percentiles;

  useEffect(() => {
    let cancelled = false;
    async function getPercentiles() {
      setLoading(true);

      // If asbv is not null
      if (asbv) {
        // if the type is one of the types we display percentiles for
        if ((asbv.type === 1) || (asbv.type === 2)) {
          const percentileValues = await asbvpercentile.getPercentile(db.id, asbv.columnName);

          if (cancelled) {
            return;
          }

          setASBVPercentiles(percentileValues);
          setPercentiles(getDisplayedPercentiles(percentileValues));
        }
        // if it's not, just return nothing
        else {
          return;
        }
      }

      setLoading(false);
    }
    getPercentiles();

    return () => {
      cancelled = true;
    };
  }, [asbv, db]);

  return (
    <div className="sg-asbv-percentile-table">
      <div className="percentile__table">
        <ScrollShadow>
          <Paper
            className="percentile__table-paper"
            elevation={0}
            square
          >
            <table>
              <thead>
                <tr>
                  {displayedPercentiles.map((p) => (
                    <th key={p.percentileType}>
                      <PercentileTag percentile={p.percentileType} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {displayedPercentiles.map((p) => (
                    <td key={p.percentileType}>{p.value}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </Paper>
        </ScrollShadow>
      </div>
    </div>
  );
};
